import React from 'react';
import { Button, Card, ButtonToolbar } from 'react-bootstrap'

import './style';

class Popup extends React.Component {
    render() {
      return (
        <div className='popup'>
          <Card className='popup_inner'>
<Card.Header className="header">Contact Me</Card.Header>
  <Card.Body>
    <Card.Text className="text-body">
Please feel free to contact me via email, telephone, or LinkedIn. Otherwise let's setup a Zoom/ Skype call!   
 </Card.Text>
    <ButtonToolbar>
     <Button variant="success" size="lg" block href="tel:209-694-6171" target="_blank"><i class="fas fa-phone"></i> Call Me</Button>
     <Button variant="info" size="lg" block href="mailto:natespring92@gmail.com" target="_blank"><i class="fas fa-envelope"></i> Email Me</Button>
     <Button variant="danger" size="md" block onClick={this.props.closePopup}>Close</Button>
  </ButtonToolbar>
  </Card.Body>
</Card>
          </div>
      );
    }
  }
export default Popup



// WEBPACK FOOTER //
// ./src/components/Contact/Contact.js